<template>
  <div class="entry-overview flex overflow-hidden bg-white shadow sm:rounded-lg">
    <div class="entry-detail w-full">
      <div class="flex flex-col">
        <!-- Header -->
        <DestinationHeader
          :destination="destination">
          <template #button>
            <button
              type="button"
              class="inline-flex items-center rounded-md border border-black py-1 pl-2 pr-4 text-sm font-medium
                text-black shadow-sm hover:border-purple-700 hover:bg-purple-700 hover:text-white focus:outline-none
                focus:ring-2 focus:ring-purple-800 focus:ring-offset-2"
              @click="toggleModal">
              <PlusSmallIcon
                class="size-6"
                aria-hidden="true" /> <span class="ml-1">Add more entities</span>
            </button>
          </template>
        </DestinationHeader>
        <!-- Main content -->
        <main>
          <DestinationMapEntites
            :destination="destination"
            v-bind="$attrs" />
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* local */
import DestinationHeader from '@/Pages/Destination/Components/DestinationHeader.vue';
import DestinationMapEntites from '@/Pages/Destination/Components/DestinationMapEntites.vue';
import { PlusSmallIcon } from '@heroicons/vue/24/outline';
import {
  provide, ref,
} from 'vue';

/* Define props */
defineProps({
  destination: {
    type: Object,
    required: true,
  },
});

const showCreateEntityModal = ref(false);
provide('showCreateEntityModal', showCreateEntityModal);

/**
 * Toggle the entity creation modal.
 */
function toggleModal() {
  showCreateEntityModal.value = !showCreateEntityModal.value;
}

</script>
